<template>
  <div class="product-type-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>位置：</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品分类</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <el-row class="conentRow">
        <div style="display: flex; align-items: center;">
          <el-col class="conentBtn">
            <el-button type="primary" @click="openAdd">添加类型</el-button>
          </el-col>
          <el-col class="conentBtn" style="margin-left: 10px;">
            <el-button type="primary" plain @click="fetchList">刷新</el-button>
          </el-col>
        </div>
      </el-row>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
      >
        <el-table-column prop="typeid" label="ID" width="90" />
        <el-table-column prop="typename" label="类型名称" align="left" header-align="left" />
        <!-- <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.typestate == 1 ? 'success' : 'info'" size="small">
              {{ scope.row.typestate == 1 ? '显示' : '隐藏' }}
            </el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
            <el-popconfirm
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="确定删除该类型吗？"
              @confirm="onDelete(scope.row)"
            >
              <span slot="reference" class="link-danger">删除</span>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <div><span class="demonstration">共{{ total }}条类型，</span>
          <span class="demonstration">当前显示第{{ page }}页</span></div>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="page_size"
          :current-page="page"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>

    <!-- 添加 / 编辑 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="480px"
      :close-on-click-modal="false"
      @closed="onDialogClosed"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="类型名称" prop="typename">
          <el-input v-model="form.typename" placeholder="请输入类型名称" maxlength="50" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProductTypeList,
  addProductType,
  updateProductType,
  getProductTypeInfo,
  deleteProductType
} from '@/request/scenic.js'

export default {
  name: 'ProductTypeList',
  data() {
    return {
      loading: false,
      tableData: [],
      dialogVisible: false,
      dialogTitle: '添加类型',
      editId: null,
      form: {
        typename: ''
      },
      detailInfo: {
        scenicid: null
      },
      page: 1,
      page_size: 12,
      total: 0,
      rules: {
        typename: [{ required: true, message: '请输入类型名称', trigger: 'blur' }]
      },
      submitting: false
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    token() {
      return window.sessionStorage.getItem('Token')
    },
    fetchList() {
      this.loading = true
      getProductTypeList({
        token: this.token(),
        page: this.page,
        page_size: this.page_size
      })
        .then(res => {
          if (res.data && res.data.status === 'ok') {
            const r = res.data.result || {}
            this.tableData = (r.data && Array.isArray(r.data)) ? r.data : []
            this.total = r.total || 0
          } else {
            this.tableData = []
            this.total = 0
            if (res.data && res.data.msg) {
              this.$message.warning(res.data.msg)
            }
          }
        })
        .catch(() => {
          this.tableData = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    openAdd() {
      this.editId = null
      this.detailInfo = { scenicid: null }
      this.dialogTitle = '添加类型'
      this.form.typename = ''
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    openEdit(row) {
      this.editId = row.typeid
      this.dialogTitle = '编辑类型'
      this.form.typename = row.typename || ''
      this.detailInfo = { scenicid: null }
      this.dialogVisible = true
      getProductTypeInfo({ token: this.token(), typeid: String(row.typeid) })
        .then(res => {
          if (res.data && res.data.status === 'ok' && res.data.result) {
            const d = res.data.result
            this.form.typename = d.typename || ''
            this.detailInfo.scenicid = d.scenicid
          }
        })
        .catch(() => {})
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    onDialogClosed() {
      this.editId = null
      this.form.typename = ''
      this.detailInfo = { scenicid: null }
    },
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.submitting = true
        if (this.editId != null) {
          updateProductType({
            token: this.token(),
            typeid: String(this.editId),
            typename: this.form.typename.trim()
          })
            .then(res => {
              if (res.data && res.data.status === 'ok') {
                this.$message.success(res.data.msg || '保存成功')
                this.dialogVisible = false
                this.fetchList()
              } else {
                this.$message.error((res.data && res.data.msg) || '保存失败')
              }
            })
            .finally(() => {
              this.submitting = false
            })
        } else {
          addProductType({
            token: this.token(),
            typename: this.form.typename.trim()
          })
            .then(res => {
              if (res.data && res.data.status === 'ok') {
                this.$message.success(res.data.msg || '添加成功')
                this.dialogVisible = false
                this.fetchList()
              } else {
                this.$message.error((res.data && res.data.msg) || '添加失败')
              }
            })
            .finally(() => {
              this.submitting = false
            })
        }
      })
    },
    handlePageChange(page) {
      this.page = page
      this.fetchList()
    },
    onDelete(row) {
      deleteProductType({ token: this.token(), typeid: String(row.typeid) }).then(res => {
        if (res.data && res.data.status === 'ok') {
          this.$message.success(res.data.msg || '删除成功')
          this.fetchList()
        } else {
          this.$message.error((res.data && res.data.msg) || '删除失败')
        }
      })
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({ row, column, rowIndex, columnIndex })
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({ row, rowIndex })
    }
  }
}
</script>

<style lang="less" scoped>
.product-type-page {
  /deep/.el-card__body {
    padding: 0 20px 20px;
  }
}
.conentBox {
  margin-top: 17px;
  .conentRow {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .conentBtn {
      margin-bottom: 10px;
      .el-button {
        width: 100px;
        background: #246deb;
        border-radius: 4px;
        font-family: '.PingFang SC', sans-serif;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }
}
.pagination {
  margin-top: 16px;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.text-muted {
  color: #909399;
  font-size: 14px;
}
/deep/.el-button--primary.is-plain {
  border-color: #246deb;
  color: #246deb;
}
.link-danger {
  color: #f56c6c;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}
</style>
